import React, { Component } from 'react';

import Navigation from './navigation';
import './App.css';

class App extends Component {
  render() {
    return (
      <Navigation />
    );
  }
}

export default App;
